import type { NumPadProps } from "~/components";
import { Dialog, NumPad } from "~/components";

type NumPadDialogProps = {
  value: number;
  onChange: (value: number) => void;
  setOpen: (value: boolean) => void;
  open: boolean;
  maximum?: number;
} & Pick<NumPadProps, "variant" | "placeholder" | "children" | "currency">;

export const NumPadDialog = ({
  value,
  onChange,
  setOpen,
  open,
  children,
  maximum = Infinity,
  ...rest
}: NumPadDialogProps) => {
  return (
    <Dialog
      onOutsideClick={() => {
        setOpen(false);
      }}
      open={open}
      size="md"
    >
      <div className="flex w-full">
        <NumPad maximum={maximum} setValue={onChange} value={value} {...rest}>
          {children}
        </NumPad>
      </div>
    </Dialog>
  );
};
